import * as React from "react";
import {useEffect, useState} from "react";
import {Alert, Col, Row} from "react-bootstrap";
import {Feature, hasFeature} from "../utils/features";
import {
    IMAGES,
    KButton,
    KBUTTON_SIZE,
    KBUTTON_TYPE,
    KBUTTON_VARIANT,
    KContainer,
    KForm,
    KInput,
    KSpace,
    KSpinner,
    Translate
} from "@kopjra/uikit";
import {currentLocation} from "../utils/router.tsx";
import {useLoginMutation} from "../api/user.ts";
import {useTranslation} from "react-i18next";

export const Login: React.FC = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [triggerLogin, {isLoading: isLoggingIn, error}] = useLoginMutation();

    async function handleSubmit() {
        await triggerLogin({ username, password, from: currentLocation.state && currentLocation.state.from});
    }

    useEffect(() => {
        if (error) {
            console.error(error);
        }
    }, [error]);

    const {t} = useTranslation();
    
     return (
        <KContainer>
            <Row style={{paddingTop: 80}}>
                <Col className="text-center">
                    <img alt="logo" src={IMAGES["web-forensics"].still.large.dark} height={110}/>
                </Col>
            </Row>
            <Row style={{marginTop: 60}}>
                <Col className="text-center" md={{span: 4}} xs={12}>
                    <Alert show={!!error} dismissible={true} variant="danger">
                        {error ? t("error.login") : null}
                    </Alert>
                    <KForm onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                <KInput id={"username"} value={username} onChange={event => setUsername(event.currentTarget.value)}
                                        placeholder={t("login.username")} required={true} disabled={isLoggingIn}/>
                            </Col>
                        </Row>
                        <KSpace/>
                        <Row>
                            <Col>
                                <KInput id={"password"} value={password} onChange={event => setPassword(event.currentTarget.value)}
                                        placeholder={t("login.password")} required={true} disabled={isLoggingIn} type={"password"}/>
                            </Col>
                        </Row>
                        {hasFeature(Feature.GFL) ? (
                            <Row style={{marginTop: 5}}>
                                <Col className="text-end">
                                    <KButton text={<Translate i18nKey="login.lostPassword"/>}
                                             variant={KBUTTON_VARIANT.link}
                                             size={KBUTTON_SIZE.xs}
                                             onClick={() => {window.open("https://clienti.giuffre.it/UserManager/ResetPassword.aspx?prod=155", "_blank");}}
                                    />
                                </Col>
                            </Row>
                        ) : null}
                        {hasFeature(Feature.AUTH0) ? (
                            <Row style={{marginTop: 5}}>
                                <Col className="text-end">
                                    <KButton text={""}
                                             variant={KBUTTON_VARIANT.link}
                                             onClick={() => { window.open("/", "_blank"); }}
                                     />
                                </Col>
                            </Row>
                        ) : null}
                        <Row style={{marginTop: 11}}>
                            <Col>
                                <KButton text={isLoggingIn ? <KSpinner/> : <><i className="fal fa-lg fa-sign-in-alt"/>&nbsp;&nbsp;<Translate i18nKey={hasFeature(Feature.AUTH0) ? "login.internal" : "login.button"}/></>}
                                         variant={KBUTTON_VARIANT.primary}
                                         type={KBUTTON_TYPE.submit}
                                         disabled={isLoggingIn}
                                         fill={true}
                                />
                                {/*<Button variant="primary" className="loginButton" type="submit" disabled={logging}>*/}
                                {/*    {logging ? (*/}
                                {/*        <i className="fal fa-lg fa-circle-notch fa-spin"/>*/}
                                {/*    ) : (*/}
                                {/*        <><i className="fal fa-lg fa-sign-in-alt"/>&nbsp;&nbsp;<Translate i18nKey={hasFeature(Feature.AUTH0) ? "login.internal" : "login.button"}/></>*/}
                                {/*    )}*/}
                                {/*</Button>*/}
                            </Col>
                        </Row>
                    </KForm>
                </Col>
            </Row>
        </KContainer>
    );
};
